import SolarGrid from './SolarGrid.vue';

export default SolarGrid;
